import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";
import gsap from 'gsap';

var ListingThreeUpProjectsSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingThreeUpProjectsSlider',
	};

	$.extend(true, this.options, options);

};

ListingThreeUpProjectsSlider.prototype.init = function() {

	var self = this;
	
	this.$heading = this.options.$el.find(`.${self.options.baseClass}__componentHeading`);

	// sliders
	this.$cardSlider = this.options.$el.find(`.${self.options.baseClass}__cardSlider`);

	// position slider on large screens
	this.$cardSlider.on('init', function() {
		self.positionSlider();
	});

	// initialize card slider
	this.$cardSlider.slick({
		arrows: false,
		fade: false,
		speed: 750,
		swipeToSlide: true,
		infinite: false,
		variableWidth: true,

		responsive: [
		
			{
				breakpoint: 768,
				settings: {
					centerMode: true,
					centerPadding: '0px',
					variableWidth: false,
					slidesToShow: 1,
				}
			},

		],

	});

	// previous/next buttons
	this.options.$el.find(`.${self.options.baseClass}__previousButton`).on('click', function() {
		self.$cardSlider.slick('slickPrev');
	});

	this.options.$el.find(`.${self.options.baseClass}__nextButton`).on('click', function() {
		self.$cardSlider.slick('slickNext');
	});

	this.$cardSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	
		self.updateSlideCounter(nextSlide + 1);

	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideCounterEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__slideCounter, .${self.options.baseClass}__slideNumber`) );

	this.slideCounterEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideCounterEq.equalizeHeights();
		self.positionSlider();
	});

};

ListingThreeUpProjectsSlider.prototype.updateSlideCounter = function(slideNumber){

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__slideNumber`).removeClass(`${self.options.baseClass}__slideNumber--active`);

	this.options.$el.find(`.${self.options.baseClass}__slideNumber` + '[data-slide-number="' + slideNumber + '"]').addClass(`${self.options.baseClass}__slideNumber--active`);

};

ListingThreeUpProjectsSlider.prototype.positionSlider = function(){

	var self = this;

	var breakpoint = window.Breakpoint.value;
	var headingOffset = this.$heading.offset().left;
	var sliderOffset = headingOffset - 24;

	var $slickTrack = this.options.$el.find(`.slick-track`);

	console.log(breakpoint);
	console.log(headingOffset);
	
	if (breakpoint == 'xlarge' || breakpoint == 'xxlarge') {
		
		gsap.set($slickTrack, {
			left: sliderOffset
		});

	}
	else {

		gsap.set($slickTrack, {
			clearProps: 'left'
		});

	}

};

// Math.max.apply(Math, $('.image').map(function(){ return $(this).width(); }).get());

export default ListingThreeUpProjectsSlider;
